import { render, staticRenderFns } from "./BookingVideoRoom.vue?vue&type=template&id=4bb3762a&scoped=true"
import script from "./BookingVideoRoom.vue?vue&type=script&lang=js"
export * from "./BookingVideoRoom.vue?vue&type=script&lang=js"
import style0 from "./BookingVideoRoom.vue?vue&type=style&index=0&id=4bb3762a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb3762a",
  null
  
)

export default component.exports